import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindUserRolesParams = {
  organizationId: string;
  userId: number;
  filters: Record<string, unknown>;
};

function getUserRolesHelper(organizationId: string, userId: number) {
  return clientApi.getOCClient().helpers.employer.organizations.id(organizationId).users.id(userId)
    .roles;
}

const { useGet: useOrganizationUserRoles, useUpdate: useOrganizationUserRolesUpdate } =
  getCRUDHooks({
    entityName: 'organizationUserRole',
    get: ({ organizationId, userId, filters }: FindUserRolesParams) =>
      getUserRolesHelper(organizationId, userId).find(filters),
    update: (newRoles, { organizationId, userId }) =>
      getUserRolesHelper(organizationId, userId).partialUpdate('', newRoles),
  });

export { useOrganizationUserRoles, useOrganizationUserRolesUpdate };
